import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { SelectValueProps } from "reka-ui"
import { SelectValue } from "reka-ui"


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectValue',
  props: {
    placeholder: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SelectValue), _mergeProps({ "data-slot": "select-value" }, props), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})